import {RoomDoor} from './RoomDoor';
import {RoomType} from '../enums/RoomType';
import {RoomColor} from '../enums/RoomColor';

export class Room {
  id: number;
  name: string;
  nameHe: string;
  area: number;
  capacity: number;
  description: string;
  image: string;
  color: RoomColor;
  type: RoomType;
  officeId: number;
  doors: RoomDoor[];

  public constructor(init?: Partial<Room>) {
    Object.assign(this, init);
  }
}
